import { useState, useEffect } from 'react';
import axios from 'axios';

const cache = {};

const useSeoOverrides = (slug) => {
  const [overrides, setOverrides] = useState(cache[slug] || null);

  useEffect(() => {
    if (!slug) return;
    if (cache[slug]) { setOverrides(cache[slug]); return; }
    axios.get(`/api/seo/page/${slug}`)
      .then(res => {
        if (res.data.found) {
          cache[slug] = res.data;
          setOverrides(res.data);
        }
      })
      .catch(() => {});
  }, [slug]);

  return overrides;
};

export default useSeoOverrides;
